import type { Vehicle } from '../vehicle/vehicle.interface';
import { VEHICLE_STATUS } from '../vehicle/vehicle.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class VehicleFactory extends ObjectFactory<Vehicle> {
  protected getDefaults(): Vehicle {
    return {
      ...baseDocumentFactory.build(),
      carrierId: 'aabbccddeeff001122334455',
      licensePlate: 'AB-123-CD',
      siteIds: [],
      spaceId: 'bbbbbbbbbbbbbbbbbbbbbbbb',
      status: VEHICLE_STATUS.AVAILABLE,
      vehicleTemplateId: 'cccccccccccccccccccccccc',
    };
  }
}

export const vehicleFactory = new VehicleFactory();
